<template>
    <pml-select v-model="model" :options="options" :allow-empty="onlyFollow || (member.is_admin ? true : allowEmpty)" :placeholder="placeholder" label="full_name" @input="onChange" :disabled="disabled"></pml-select>
</template>

<script>
    import { trans } from '@/utils/helpers/translation'
    import { removeById } from '@/utils/helpers/arrays'
    import { filter, cloneDeep } from 'lodash'
    import { mapGetters } from 'vuex'

    export default {
        data () {
            return {
                model: ''
            }
        },
        props: {
            'value': {
                default: () => ''
            },
            'removeFromOptions': {
                type: Number,
                default: () => null
            },
            'all': {
                type: Boolean,
                default: () => false
            },
            'placeholder': {
                type: String,
                default: () => trans('select_an_option')
            },
            'onlyMe': {
                type: Boolean,
                default: () => false
            },
            'onlyActive': {
                type: Boolean,
                default: () => false
            },
            'onlyFollow': {
                type: Boolean,
                default: () => false
            },
            'disabled': {
                type: Boolean,
                default: () => false
            },
            'allowEmpty': {
                type: Boolean,
                default: () => false
            }
        },
        computed: {
            ...mapGetters({
                'member': 'getMember',
                'members': 'getMembers',
                'activeMembers': 'getActiveMembers'
            }),
            options () {
                if (this.onlyActive)
                    return this.getActiveOptions()

                return this.getAllMembers()
            }
        },
        mounted () {
            if ((this.value === null || this.value === '') && !this.member.is_admin && !this.onlyFollow) {
                this.model = this.member.id
                this.onChange(this.model)
            } else {
                this.model = this.value
            }
        },
        watch: {
            value (val) {
                this.model = val
            }
        },
        methods: {
            onChange (value) {
                this.$emit('input', value)
            },
            getActiveOptions () {
                let members = cloneDeep(this.activeMembers(this.model))

                members = this.removeFromOptions === null
                    ? members || []
                    : removeById(members, this.removeFromOptions) || []

                return (this.member.is_admin || this.onlyFollow ? members : filter(members, { id: this.member.id })) || []
            },
            getAllMembers () {
                let members = cloneDeep(this.members)
                members = !this.removeFromOptions ? members : removeById(members, this.removeFromOptions)

                if (this.all)
                    return members || []

                if (this.onlyMe)
                    return filter(members, { id: this.member.id }) || []

                return (this.member.is_admin || this.onlyFollow ? members : filter(members, { id: this.member.id })) || []
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/form/selects/Members.vue